<div class="iss-global-spinner-overlay" *ngIf="visible">
  <img
    class="iss-global-spinner-logo"
    [src]="'wo-common/assets/swc-logo_180x166.webp' | woFileHash"
    alt="loading"
  />
  <div class="iss-global-spinner-message">
    {{ 'iss-core.global-spinner.message' | translate }}
  </div>
</div>
<ng-content/>
